import { render, staticRenderFns } from "./CompleteUserPage.vue?vue&type=template&id=7ff96d3e&scoped=true&"
import script from "./CompleteUserPage.vue?vue&type=script&lang=ts&"
export * from "./CompleteUserPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteUserPage.vue?vue&type=style&index=0&id=7ff96d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff96d3e",
  null
  
)

export default component.exports